import React, { useState } from "react";
import { db } from "../components/firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

 const Contact = () => {

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [successs, setSuccess] = useState('');

     const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    try {
      await addDoc(collection(db, "messages"), {
        firstName,
        lastName,
        email,
        message,
        createdAt: serverTimestamp(),
      });
      
      setEmail(""); // reset input
      setFirstName("");
      setLastName("");
      setMessage("");
      setSuccess("Message Sent Successfully!");
      
    } catch (err) {
      console.error("Error saving email:", err);
      setMessage("❌ Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };


    return(
    <section className="contact">
        <h2>Contact Me</h2>
        <form onSubmit={handleSubmit}>
            <input type="text" value={firstName} name="name" placeholder="Your first name" onChange={(e) => setFirstName(e.target.value)} required />
            <input type="text" value={lastName} name="name" placeholder="Your last name" onChange={(e) => setLastName(e.target.value)} required />
            <input type="email" value={email} name="email" placeholder="Your email" onChange={(e) => setEmail(e.target.value)} required />
            <textarea value={message} name="message" placeholder="Your message" rows="5" onChange={(e) => setMessage(e.target.value)} required />
            <button type="submit">{loading ? "Sending Message" : "Send Message"}</button>
        </form>
            <p>{successs}</p>
    </section>
    );
};

export default Contact;